import script from "./signView.vue?vue&type=script&setup=true&lang=js"
export * from "./signView.vue?vue&type=script&setup=true&lang=js"

import "./signView.vue?vue&type=style&index=0&id=27414bf0&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27414bf0"]])

export default __exports__